
<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Deudas entre Clubes</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
    <DataTable :headers="headers" :path="path" actionButtonsName="DeudasListActionButtons" :properties="properties"
    filter :filterPath="filterPath">
    </DataTable>
    </div>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="addDeuda">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>
import DataTable from '../../../common/ui/DataTable.vue'
export default {

  components: {
    DataTable
  },

  data () {
    return {
      loading: true,
      path: 'deudas',
      filterPath: 'filter/deudas'
    }
  },

  methods: {
    addDeuda () {
      this.$router.push({ name: 'deudaNueva' })
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddDeudas
    },
    headers () {
      let headers = [
        { text: 'Club acreedor', value: 'club_acreedor', filterField: true },
        { text: 'Transferencia', value: 'jugador', filterField: true },
        { text: 'Estado', value: 'estado', filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(0, 0, { text: 'Club Deudor', value: 'club_deudor', align: 'left', filterField: true })
      }
      return headers
    },
    properties () {
      const propiedades = ['clubAcreedor.nombre', 'jugador', 'estadoDisplay']
      if (this.$store.getters.isSafRole) {
        propiedades.splice(0, 0, 'clubDeudor.nombre')
      }
      return propiedades
    }
  },
  mounted () {
    this.loading = false
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em;
  }
</style>
